module.exports = new __parcel__URL__("demonskull.abce51c0.png").toString();